const benefits = [
  {
    icon: 'ri-calculator-line',
    color: 'from-teal-500 to-emerald-500',
    bgLight: 'bg-teal-50',
    title: 'Calcul précis des glucides',
    description: 'Obtenez instantanément la teneur en glucides de chaque aliment et de votre repas complet. Mise à jour en temps réel lors des modifications de portions.',
    highlight: 'Temps réel',
  },
  {
    icon: 'ri-award-line',
    color: 'from-lime-500 to-green-500',
    bgLight: 'bg-lime-50',
    title: 'Nutri-Score instantané',
    description: 'Évaluez la qualité nutritionnelle de vos repas avec le Nutri-Score (A à E) et recevez des conseils personnalisés pour améliorer votre alimentation.',
    highlight: 'Score A à E',
  },
  {
    icon: 'ri-database-2-line',
    color: 'from-sky-500 to-blue-500',
    bgLight: 'bg-sky-50',
    title: 'Bibliothèque alimentaire',
    description: 'Accédez à une base de données complète d\'aliments avec leurs valeurs nutritionnelles, index glycémique et conseils adaptés aux diabétiques.',
    highlight: '200+ aliments',
  },
  {
    icon: 'ri-heart-pulse-line',
    color: 'from-rose-500 to-pink-500',
    bgLight: 'bg-rose-50',
    title: 'Aide à la décision',
    description: 'Recevez des suggestions intelligentes pour optimiser vos repas, réduire l\'impact glycémique et mieux gérer votre boucle fermée.',
    highlight: 'IA intégrée',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-teal-50 text-teal-600 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Pourquoi DT1 Simply Menu ?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Conçu pour les diabétiques de type 1
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Une application pensée pour simplifier la gestion quotidienne de votre alimentation sous boucle fermée.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="group bg-white border border-gray-100 rounded-2xl p-6 hover:border-teal-200 transition-all duration-300 cursor-default"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${b.color} mb-5`}>
                <i className={`${b.icon} text-white text-xl`}></i>
              </div>
              <span className={`inline-block ${b.bgLight} text-xs font-semibold px-2 py-0.5 rounded-full mb-3 text-gray-600`}>
                {b.highlight}
              </span>
              <h3 className="font-bold text-gray-900 text-base mb-2">{b.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
